import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Mail, MapPin, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Pradžia', path: '/' },
    { label: 'Rūšiavimo ABC', path: '/rusiavimo-abc' },
    { label: 'Kaip Rūšiuoti', path: '/kaip-rusiuoti' },
    { label: 'Mitai ir DUK', path: '/mitai-ir-duk' },
  ];

  const resources = [
    { label: 'Gamtos Ateitis', url: 'https://gamtosateitis.lt' },
    { label: 'Žaliasis Taškas', url: 'https://www.zaliasistaskas.lt' },
    { label: 'AAA Atliekų Aikštelės', url: 'https://aaa.lrv.lt' },
  ];

  return (
    <footer className="bg-muted border-t border-border mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-gradient-hero rounded-lg flex items-center justify-center">
                <Leaf className="w-6 h-6 text-white" />
              </div>
              <span className="text-lg font-bold">Rūšiavimo Gidas</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Informacinis portalas apie atliekų rūšiavimą Lietuvoje. 
              Padedame mokytis teisingai rūšiuoti ir saugoti aplinką.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4">Greita Navigacija</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>
                    <Button
                      variant="link"
                      className="p-0 h-auto font-normal text-muted-foreground hover:text-primary"
                    >
                      {link.label}
                    </Button>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Naudingos Nuorodos</h3>
            <ul className="space-y-2">
              {resources.map((resource) => (
                <li key={resource.url}>
                  <a
                    href={resource.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-sm text-muted-foreground hover:text-primary transition-smooth"
                  >
                    {resource.label}
                    <ExternalLink className="w-3 h-3 ml-1" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold mb-4">Informacija</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <span>Lietuva</span>
              </li>
              <li className="flex items-start space-x-2 text-sm text-muted-foreground">
                <Mail className="w-4 h-4 mt-0.5 flex-shrink-0 text-primary" />
                <span>info@rusiavimas.lt</span>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-muted-foreground text-center md:text-left">
            © {currentYear} Rūšiavimo Gidas. Visos teisės saugomos.
          </p>
          <p className="text-sm text-muted-foreground text-center md:text-right">
            Sukurta siekiant švarios ir tvaresnės Lietuvos aplinkos
          </p>
        </div>
      </div>
    </footer>
  );
};